import Form from "react-bootstrap/Form";
import { Container } from "./styles";

function Footer() {
  return (
    <Container>
      <footer>Copyright 2022 © - Chatbot™</footer>
    </Container>
  );
}

export default Footer;
